<template>
  <div>
    <div
      :id="'custom-slider-' + _uid"
      ref="slider"
      class="custom-slider"
      :class="'custom-slider-type-' + (type || 'unknown')"
    ></div>
  </div>
</template>

<script>
import noUiSlider from "nouislider";
import wNumb from "wnumb";

export default {
  name: "Slider",
  props: {
    decimals: {
      type: Number,
      default: 0,
      required: false,
    },
    min: {
      type: Number,
      default: 0,
      required: true,
    },
    max: {
      type: Number,
      default: 100000,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: null,
    },
    tips: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      content: this.value,
      localMin: this.min,
      localMax: this.max,
    };
  },
  watch: {
    content(value) {
      this.$emit("input", value);
    },
    value(value) {
      this.$refs.slider.noUiSlider.set(value, false);
    },
  },
  mounted() {
    if (this.localMin === this.localMax) {
      this.localMin--;
      this.localMax++;
      console.log(
        `Slider mounted with equal min and max, changed to ${this.localMin} and ${this.localMax}`
      );
      return;
    }

    this.intializeSlider();
  },
  methods: {
    intializeSlider() {
      const self = this;

      let connect = new Array(this.content.length - 1).fill(true);
      connect.unshift(false);
      connect.push(false);

      const tooltips = new Array(this.content.length).fill(
        this.tips? wNumb({ decimals: this.decimals }): false
      );

      noUiSlider
        .create(document.getElementById("custom-slider-" + this._uid), {
          connect: connect,
          start: this.content,
          step: this.decimals ? Math.pow(10, this.decimals * -1) : 1,
          range: {
            min: this.localMin,
            max: this.localMax,
          },
          tooltips: tooltips,
        })
        .on("set.one", function (e) {
          self.content = e.map((v) => {
            return this.decimals === 0 ? parseInt(v) : parseFloat(v);
          });
        });
    },
  },
};
</script>

<style lang="scss">
@import "~nouislider/distribute/nouislider.css";
@import "./../../../styles/variables";

.custom-slider {
  height: 8px;
  background-color: $slider-gray;
  border-radius: 2px;
  .noUi-connects {
    background-image: linear-gradient(to right, $white, $white);
  }
  &.custom-slider-type-recency,
  &.custom-slider-type-size {
    .noUi-connect {
      background: none;
    }
    .noUi-handle {
      top: -3px !important;
    }
  }
  &.custom-slider-type-distance {
    margin-top: 3px !important;
    .noUi-connects {
      background-image: linear-gradient(
        to right,
        $creax,
        $yellow
      );
    }
  }
  &.custom-slider-type-recency {
    .noUi-connects {
      background-image: linear-gradient(
        to right,
        $purple,
        $yellow,
        $secondary-orange 
      );
    }
  }
  &.custom-slider-type-size {
    background: #e0e0e0;
    .noUi-connects {
      background-image: linear-gradient(
        to right,
        $primary-cyan,
        $dark-cyan 
      );
    }
  }
}
.noUi-base {
  cursor: pointer;
}
.noUi-connect {
  background: $white;
}
.noUi-handle {
  width: 8px !important;
  height: 16px !important;
  top: -4px !important;
  right: -4px !important;
  background: $bootstrap-light;
  border-radius: 1px;
  box-shadow: none;
  cursor: pointer;
  outline: none;
  &::before,
  &::after {
    display: none;
  }
}
.noUi-tooltip {
  background: $white;
  border: 1px solid $bootstrap-grey;
  bottom: 110%;
  font-size: 10px;
  padding: 2px 4px;
}
</style>
